import { Grid, Stack, Typography } from "@mui/material";
import { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import AccessModeMenuLabel from "./AccessModeMenuLabel.tsx";
import type { ReportCompany } from "./ShareReport.types.ts";

const allowedAccesses = [
  ReportAccessType.FullAccess,
  ReportAccessType.Write,
  ReportAccessType.Read,
  ReportAccessType.NoAccess,
];

interface Props {
  company: ReportCompany;
  access: ReportAccessType;
  disabled: boolean;
  onSelect: (access: ReportAccessType) => void;
}

export default function CompanySharingRow({ company, access, disabled, onSelect }: Props) {
  return (
    <Grid
      container
      sx={(theme) => ({
        borderWidth: 1,
        borderColor: theme.palette.divider,
        borderStyle: "solid",
        borderRadius: 1,
        py: 0.8,
        pl: 1,
        pr: 2,
        alignItems: "center",
        gap: 1.5,
        width: "100%",
      })}
    >
      <img src={company.logoMarkUrl} alt="" width={32} height={32} />
      <Stack>
        <Typography variant="subtitle2">{`Everyone at ${company.name}`}</Typography>
        <Typography variant="body2" color={"secondary"}>
          Members who have permission in the SmartViews product.
        </Typography>
      </Stack>
      <HorizontalFill />
      <AccessModeMenuLabel access={access} disabled={disabled} allowedAccesses={allowedAccesses} onSelect={onSelect} />
    </Grid>
  );
}
